import { render, staticRenderFns } from "./clientCampaigns.vue?vue&type=template&id=4c6f743e&"
import script from "./clientCampaigns.vue?vue&type=script&lang=js&"
export * from "./clientCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports